module.exports = __webpack_public_path__ + "img/images-5.101efbe5.jpg";